import { Report } from "../Interfaces/TableInterfaces";
import { Packet } from "../Interfaces/commonDtos";
import { DropdownItem } from "../Interfaces/dropdownInterfaces";
import {
  IAddOrEditSiteUserFormValues,
  IResetSiteUserPasswordFormValues,
  ISiteUsersTableReport,
  ISiteUsersTableSearchParam,
} from "../Interfaces/siteUserInterfaces";
import {
  getRequest,
  getTable,
  postRequest,
  putRequest,
} from "./requestTemplates";

export const addSiteUser = (
  formValues: IAddOrEditSiteUserFormValues
): Promise<Packet<boolean>> => postRequest("/v1/siteUser/AddUser", formValues);

export const editSiteUser = (
  formValues: IAddOrEditSiteUserFormValues
): Promise<Packet<boolean>> => putRequest("/v1/siteUser/editUser", formValues);

export const getSiteUser = (
  userId: number
): Promise<IAddOrEditSiteUserFormValues> =>
  getRequest(`/v1/siteUser/getUser?userId=${userId}`);

export const getSiteUsersTable = async (
  searchParam: ISiteUsersTableSearchParam,
  offset: number | null,
  pageSize: number | null
): Promise<Report<ISiteUsersTableReport>> =>
  getTable<ISiteUsersTableSearchParam, ISiteUsersTableReport>(
    "/v1/siteuser/table",
    searchParam,
    offset,
    pageSize
  );

export const disableSiteUser = (userId: number): Promise<Packet<boolean>> =>
  putRequest(`/v1/SiteUser/disableUser?UserId=${userId}`);

export const enableSiteUser = (userId: number): Promise<Packet<boolean>> =>
  putRequest(`/v1/SiteUser/enableUser?UserId=${userId}`);

export const resetSiteUserPassword = (
  formValues: IResetSiteUserPasswordFormValues
): Promise<Packet<boolean>> =>
  putRequest(`/v1/siteuser/resetpassword`, formValues);

export const getSiteUsers = (): Promise<DropdownItem[]> =>
  getRequest("/v1/SiteUser/getUsers");

export const getAssignableSahraUserGroups = (): Promise<DropdownItem[]> =>
  getRequest("/v1/SiteUser/getAssignableSahraUserGroups");
